import * as React from "react";
import {cx} from "emotion";

import "./template-selection-template-view.scss";

import {isUyoMPB}   from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {cs}         from "@Common/react/chain-services";
import {UseState}   from "@Common/react/use-state";
import {Responsive} from "@Common/ui-components/responsive";
import {oMapToArr}  from "@Common/utils/objects";

import {BackTemplateSelector} from "./back-template-selector/back-template-selector";
import {FrontTemplateViewer}  from "./front-template-viewer/front-template-viewer";

export const TemplateSelectionTemplateView = ({
    templateOptions,
    templateBack,
    selected,
    oia,
    isFromApproval,
    item,
    itemOptions,
    view,
    gallery,
    next,
}) => cs(
    ["frontBackState", (_, next) => UseState({
        initValue: {mode: "front"},
        next,
    })],
    ["frontTemplateViewer", (_, next) => FrontTemplateViewer({
        ...(isUyoMPB(templateOptions) && item?.metaData?.pdfValidation?.thumbnails?.length > 0) ? {
            label: "Your Upload",
            images: item?.metaData?.pdfValidation?.thumbnails?.map(url => ({url})),
            view,
            gallery,
        } : oia ? {
            label: "Your Proof",
            images: oia.proofs?.map(url => ({url})),
            view,
            gallery,
            loading: oia.loading,
        } : itemOptions.variationsThumbnails ? {
            activeKey: itemOptions.variationsThumbnails.activeItemIndex,
            label: templateOptions?.name,
            images: itemOptions.variationsThumbnails.items.map(({onSelect, ...img}) => ({...img, onClick: onSelect})),
            view,
            gallery,
        } : {
            label: templateOptions?.name,
            images: templateOptions?.thumbnails ? (
                oMapToArr(templateOptions?.thumbnails, (img) => img)
            ) : (
                templateBack?.images
            ),
            view,
            gallery,
        },
        next,
    })],
    ["backTemplateSelector", (_, next) => (!oia && !templateOptions?.thumbnails && templateBack?.backs?.length > 0) ? (
        BackTemplateSelector({
            next,
            templateBacks: templateBack.backs,
            isFromApproval,
            item,
            selected
        })
    ) : (
        next()
    )],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ({backTemplateSelector, frontTemplateViewer, responsive, frontBackState}) => next({
        render: () => (
            <div className="template-selection-template-view template-selection-template-view-k99">
                {responsive.lt("mobile") ? (
                    <>
                        {backTemplateSelector && (
                            <div className="tabs">
                                <div
                                    onClick={() => frontBackState.onChange({mode: "front"})}
                                    className={cx("tab", {"selected": frontBackState.value.mode == "front"})}
                                    xd-qa-type="Button"
                                    xd-qa-name="Front"
                                >
                                    Front
                                </div>
                                <div
                                    onClick={() => frontBackState.onChange({mode: "back"})}
                                    className={cx("tab", {"selected": frontBackState.value.mode == "back"})}
                                    xd-qa-type="Button"
                                    xd-qa-name="Back"
                                >
                                    Back
                                </div>
                            </div>
                        )}
                        {frontBackState.value.mode == "front" ? frontTemplateViewer?.render() : backTemplateSelector?.render()}
                    </>
                ) : (
                    <>
                        {frontTemplateViewer?.render()}
                        {backTemplateSelector?.render()}
                    </>
                )}
            </div>
        )
    }),
);
